import React from "react";
import View from "common/View";
import ActiveFlowsPerProtocolHelpModal from "./Help";
import Report from "./Report";
import { parseStateActiveSessions } from "./api";

const retrieval = () =>
  ifCl
    .run("show flow all state raw")
    .then(parseStateActiveSessions)
    .catch((error) => console.error(error) || error);

const ActiveFlowsPerProtocol = () => (
  <View
    title="Active Flows"
    Help={ActiveFlowsPerProtocolHelpModal}
  >
    <Report retrieval={retrieval} />
  </View>
);

export default ActiveFlowsPerProtocol;
